import React from "react";

import Loader from "../Loader";

const LoadingScreen: React.FC = (props) => {
  return (
    <div className="loading-screen-wrapper">
      <div className="loading-screen-content">
        <Loader size="50px" color="darkblue" {...props} />
        <div className="mt40">
          <span className="loading">Loading</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
